module.exports = __webpack_public_path__ + "static/media/M011-account.b95a09b0.svg";